import React from 'react'
import { IdentifyWithEmailForm } from '@/features/auth'
import { BaseView } from '@/components'
import { IdentifierHeader } from '@/features/auth/identifier/components/IdentifierHeader'

export const IdentifyWithEmailScreen: React.FC = () => {
  return (
    <BaseView flex={1} gap={20} px={12}>
      <IdentifierHeader translationKey="form:labels.enterYourEmail" />
      <div className="h-full justify-between flex flex-col">
        <IdentifyWithEmailForm />
      </div>
    </BaseView>
  )
}
